"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[886],{

/***/ 2606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(608);



function Container(param) {
    let { children , size =_lib_types__WEBPACK_IMPORTED_MODULE_2__/* .ContainerSize.full */ .B.full  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("px-6 md:px-12 py-8 md:py-12 mx-auto w-full", {
            "max-w-screen-3xl": size === _lib_types__WEBPACK_IMPORTED_MODULE_2__/* .ContainerSize.wide */ .B.wide
        }, {
            "max-w-screen-4xl": size === _lib_types__WEBPACK_IMPORTED_MODULE_2__/* .ContainerSize.full */ .B.full
        }),
        children: children
    });
}


/***/ }),

/***/ 6684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KL": function() { return /* binding */ DownIcon; },
/* harmony export */   "TR": function() { return /* binding */ Logo; },
/* harmony export */   "Tw": function() { return /* binding */ CloseIcon; },
/* harmony export */   "Uq": function() { return /* binding */ HamburgerIcon; },
/* harmony export */   "e0": function() { return /* binding */ ArrowIcon; },
/* harmony export */   "n9": function() { return /* binding */ GlobeIcon; }
/* harmony export */ });
/* unused harmony export SpinIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function ArrowIcon(param) {
    let { className ="w-12 ml-4"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 45 12",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeLinejoin: "round",
            d: "M1 6h42M38.643 1l4.91 5-4.91 5"
        })
    });
}
function DownIcon(param) {
    let { className ="w-4"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 12 5",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "currentColor",
            d: "M6 3.032C3.866 3.032 2.008 1.776 1.445 0H0c.596 2.475 3.102 4.262 6 4.262S11.404 2.475 12 0h-1.445C9.992 1.776 8.135 3.032 6 3.032z"
        })
    });
}
function HamburgerIcon(param) {
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 28 18",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "currentColor",
            d: "M.5 18h27v-3H.5v3zm0-7.5h27v-3H.5v3zM.5 0v3h27V0H.5z"
        })
    });
}
function CloseIcon(param) {
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "currentColor",
            d: "M20 2.014L17.986 0 10 7.986 2.014 0 0 2.014 7.986 10 0 17.986 2.014 20 10 12.014 17.986 20 20 17.986 12.014 10 20 2.014z"
        })
    });
}
function Logo(param) {
    let { className , classNameImage , classNameText  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 188 39",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_80_126)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        className: classNameImage,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#59BAC9",
                                d: "M7.168 18.595v-2.55c1.222 0 2.28-.988 2.28-2.305 0-1.234-.977-2.303-2.28-2.303V8.886c2.607 0 4.806 2.14 4.806 4.855 0 2.632-2.118 4.854-4.806 4.854z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#59BAC9",
                                d: "M0 39h38.61V0H0v39zM2.851 2.88h32.99v33.322H2.85V2.88z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#59BAC9",
                                d: "M31.36 27.563h-5.376v2.55h5.376v-2.55zM25.985 19.418c-2.607 0-4.806 2.139-4.806 4.854 0 1.234-.978 2.304-2.281 2.304a2.288 2.288 0 01-2.28-2.304c0-2.633-2.119-4.854-4.807-4.854-2.606 0-4.806 2.139-4.806 4.854v6.007h2.526v-6.007c0-1.234.977-2.304 2.28-2.304 1.222 0 2.281.988 2.281 2.304 0 2.633 2.118 4.855 4.806 4.855s4.806-2.14 4.806-4.855c0-1.234.977-2.304 2.28-2.304 1.304 0 2.281.988 2.281 2.304h2.526c0-2.715-2.118-4.854-4.806-4.854z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        className: classNameText,
                        fill: "#114C6B",
                        d: "M66.794 20.652c0 5.266-3.666 8.31-9.042 8.31h-4.235V12.589h4.235c5.62 0 9.042 2.962 9.042 8.063zm-2.525 0c0-3.95-2.444-5.76-6.517-5.76H55.88v11.766h1.873c3.91 0 6.517-2.139 6.517-6.006zM69.319 13.823c0-.823.651-1.399 1.547-1.399.897 0 1.548.576 1.548 1.399 0 .823-.651 1.399-1.547 1.399-.897 0-1.548-.576-1.548-1.4zm.407 3.62h2.362v11.519h-2.362V17.443zM74.288 27.234l1.384-1.563c1.06 1.07 2.118 1.563 3.503 1.563 1.303 0 2.2-.494 2.2-1.48 0-2.634-6.599-.577-6.599-5.02 0-1.975 1.71-3.538 4.48-3.538 1.955 0 3.34.659 4.399 1.646l-1.222 1.563c-.814-.74-1.792-1.234-3.095-1.234-1.466 0-2.2.576-2.2 1.399 0 2.386 6.599.658 6.599 5.019 0 2.303-2.037 3.62-4.562 3.62-2.362 0-3.747-.823-4.887-1.975zM93.593 28.221c-.896.659-1.874 1.07-3.014 1.07-2.118 0-3.747-1.07-3.747-3.867V19.5h-2.28l.488-2.057h1.792v-3.209h2.362v3.21h4.236V19.5h-4.236v5.924c0 1.152.652 1.728 1.63 1.728.733 0 1.221-.247 1.873-.658l.896 1.727zM102.716 28.962c-.082-.576-.163-1.07-.245-1.645-.733 1.234-2.036 1.892-3.665 1.892-2.362 0-3.992-1.317-3.992-3.538 0-2.222 1.874-3.703 4.97-3.703 1.058 0 1.873.165 2.606.33v-.576c0-1.646-1.059-2.551-2.77-2.551-1.303 0-2.28.411-3.176 1.07l-.896-1.728c1.14-.823 2.525-1.317 4.317-1.317 3.014 0 4.887 1.646 4.887 4.608v3.95c0 1.233.082 2.385.244 3.29h-2.28v-.082zm-.326-4.525v-.494c-.652-.165-1.385-.329-2.281-.329-2.036 0-2.932.823-2.932 1.975 0 .987.814 1.728 2.199 1.728 1.711 0 3.014-1.07 3.014-2.88zM110.291 12.589h-2.362v16.29h2.362V12.59zM131.47 21.968v6.994h-2.362v-6.747c0-1.974-.978-2.962-2.444-2.962-1.548 0-2.851.988-2.851 3.374v6.253h-2.362v-6.665c0-1.974-.978-2.962-2.444-2.962-1.548 0-2.851.988-2.851 3.374v6.253h-2.362V17.36h2.281l.081 1.646c.733-1.234 1.955-1.974 3.584-1.974s2.933.822 3.584 2.386c.815-1.481 2.2-2.386 4.073-2.386 2.362.082 4.073 1.727 4.073 4.936zM133.914 23.203c0-3.785 2.769-6.09 5.946-6.09 3.177 0 5.946 2.222 5.946 6.09 0 3.784-2.769 6.088-5.946 6.088-3.177-.082-5.946-2.304-5.946-6.088zm9.448-.083c0-2.468-1.629-3.95-3.502-3.95-1.874 0-3.584 1.482-3.584 3.95 0 2.469 1.629 3.95 3.502 3.95 1.955.082 3.584-1.4 3.584-3.95zM155.662 28.221c-.896.659-1.873 1.07-3.014 1.07-2.118 0-3.747-1.07-3.747-3.867V19.5h-2.28l.488-2.057h1.792v-3.209h2.363v3.21h4.235V19.5h-4.235v5.924c0 1.152.651 1.728 1.629 1.728.733 0 1.222-.247 1.873-.658l.896 1.727zM157.617 13.823c0-.823.652-1.399 1.548-1.399s1.548.576 1.548 1.399c0 .823-.652 1.399-1.548 1.399s-1.548-.576-1.548-1.4zm.326 3.62h2.362v11.519h-2.362V17.443zM163.075 23.203c0-3.785 2.769-6.09 5.946-6.09 3.177 0 5.946 2.222 5.946 6.09 0 3.784-2.769 6.088-5.946 6.088-3.095-.082-5.946-2.304-5.946-6.088zm9.53-.083c0-2.468-1.629-3.95-3.503-3.95-1.873 0-3.584 1.482-3.584 3.95 0 2.469 1.629 3.95 3.503 3.95 1.873.082 3.584-1.4 3.584-3.95zM188 22.133v6.829h-2.362v-6.5c0-2.14-.978-3.127-2.607-3.127-1.548 0-2.932.988-2.932 3.538v6.089h-2.363V17.443h2.281l.082 1.728c.814-1.399 2.117-2.057 3.828-2.057 2.362 0 4.073 1.645 4.073 5.019z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_80_126",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H188V39H0z"
                    })
                })
            })
        ]
    });
}
function SpinIcon(param) {
    let { className ="w-4"  } = param;
    return /*#__PURE__*/ _jsx("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
        })
    });
}
function GlobeIcon(param) {
    let { className ="w-4"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 25",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "currentColor",
            d: "M12,22c-5.2,0-9.5-4.3-9.5-9.5S6.8,3,12,3s9.5,4.3,9.5,9.5-4.3,9.5-9.5,9.5ZM11.8,21c.1,0,.3,0,.4,0,.9-1.6,1.6-3.3,2-5h-4.4c.4,1.7,1,3.4,2,5ZM15.2,16c-.3,1.7-.9,3.3-1.8,4.9,2.8-.5,5.2-2.4,6.3-4.9h-4.5ZM4.3,16c1.1,2.5,3.5,4.4,6.3,4.9-.8-1.5-1.4-3.2-1.8-4.9h-4.5ZM15.4,15h4.7c.2-.8.4-1.6.4-2.5s-.1-1.7-.4-2.5h-4.7c.2,1.7.2,3.3,0,5ZM9.6,15h4.7c.2-1.7.2-3.3,0-5h-4.7c-.3,1.7-.3,3.3,0,5ZM3.9,15h4.7c-.2-1.7-.2-3.3,0-5H3.9c-.2.8-.4,1.6-.4,2.5s.1,1.7.4,2.5ZM15.2,9h4.5c-1.1-2.5-3.5-4.4-6.3-4.9.8,1.5,1.4,3.2,1.8,4.9ZM9.8,9h4.4c-.4-1.7-1-3.4-2-5-.1,0-.3,0-.4,0-.9,1.6-1.6,3.3-2,5ZM4.3,9h4.5c.3-1.7.9-3.3,1.8-4.9-2.8.5-5.2,2.4-6.3,4.9Z"
        })
    });
}


/***/ }),

/***/ 4886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js + 4 modules
var popover = __webpack_require__(1761);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(7318);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./lib/types/index.ts
var types = __webpack_require__(608);
// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(6684);
// EXTERNAL MODULE: ./components/container.tsx
var container = __webpack_require__(2606);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__(23);
var i18n_default = /*#__PURE__*/__webpack_require__.n(i18n);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(7041);
;// CONCATENATED MODULE: ./components/nav.tsx











function Nav(param) {
    let { menu , sticky , trackingConsent  } = param;
    const router = (0,next_router.useRouter)();
    const { asPath  } = router;
    const locales = router.locales || [];
    const currentLocale = router.locale || router.defaultLocale;
    const handleLangSwitch = (e, nextLocale)=>{
        e.preventDefault();
        (0,lib.setCookie)("NEXT_LOCALE", nextLocale); // this will skip the automatic locale detection based on browser lang or ip location
        window.location.href = "/api/set-language?pathname=" + asPath + "&locale=" + currentLocale;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
        className: "bg-white fixed w-full z-20",
        children: [
            trackingConsent,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-screen-4xl mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("transition-[padding] ease-in-out duration-200 px-6 md:px-12", {
                            "py-[18px] lg:pt-8 lg:pb-[22px]": sticky,
                            "pt-8 pb-[22px] lg:pt-[80px] lg:pb-[40px]": !sticky
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative grid grid-cols-12 gap-1.5 md:gap-6 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-9 lg:col-span-3 z-30",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                        href: "/",
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Distalmotion"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Logo */.TR, {
                                                className: "h-10 w-auto",
                                                classNameText: classnames_default()("transition-opacity ease-in-out duration-200", {
                                                    "opacity-0 lg:opacity-100": sticky
                                                }, {
                                                    "opacity-1": !sticky
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-3 col-start-10 justify-self-end -my-2 -mr-2 lg:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                        className: "inline-flex items-center justify-center rounded-xl md:rounded-3xl bg-white p-2 text-blue-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Open menu"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* HamburgerIcon */.Uq, {
                                                className: "w-[28px] text-iceblue-500",
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden lg:block absolute inset-x-0 z-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "-mx-6 md:-mx-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                                            size: types/* ContainerSize.wide */.B.wide,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "grid grid-cols-12 gap-1.5 md:gap-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-start-4 col-span-9 lg:flex lg:flex-1 lg:items-center lg:justify-between text-13 leading-140 tracking-8 font-bold mt-[6px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Group */.J.Group, {
                                                        as: "nav",
                                                        className: "flex space-x-10",
                                                        children: menu.items.slice(0, -1).map((item, index)=>{
                                                            if (item.children) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
                                                                    className: "relative",
                                                                    children: (param)=>{
                                                                        let { open  } = param;
                                                                        var _item_children;
                                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                                                    className: classnames_default()("group inline-flex items-center rounded-xl md:rounded-3xl bg-white font-bold text-blue-800 tracking-8 uppercase outline-none"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: item.title
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DownIcon */.KL, {
                                                                                            className: "".concat(open ? "rotate-180 transform" : "", " ml-2 mt-1 h-1"),
                                                                                            "aria-hidden": "true"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                                                                    as: react.Fragment,
                                                                                    enter: "transition ease-out duration-200",
                                                                                    enterFrom: "opacity-0 translate-y-1",
                                                                                    enterTo: "opacity-100 translate-y-0",
                                                                                    leave: "transition ease-in duration-150",
                                                                                    leaveFrom: "opacity-100 translate-y-0",
                                                                                    leaveTo: "opacity-0 translate-y-1",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                                                                                        className: "absolute left-0 z-20 mt-3 max-w-xs transform -translate-x-8",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "overflow-hidden rounded-xl md:rounded-3xl rounded-t-none border border-blue-100 border-t-0",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "relative grid gap-6 bg-white px-5 py-6 sm:gap-6 sm:p-8 text-11 font-medium",
                                                                                                children: (_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                                        href: item.href,
                                                                                                        target: item.target,
                                                                                                        className: "-m-3 block p-3",
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            className: "text-blue-800 border-color-800 hover:border-b hover:font-bold uppercase",
                                                                                                            children: item.title
                                                                                                        })
                                                                                                    }, item.title))
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        });
                                                                    }
                                                                }, index);
                                                            }
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                className: " text-blue-800 uppercase font-bold",
                                                                href: item.href,
                                                                target: item.target,
                                                                children: item.title
                                                            }, index);
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "hidden lg:flex col-start-11 col-span-2 lg:flex-1 lg:items-center lg:justify-end lg:gap-1 text-13 leading-140 tracking-8 font-bold items-center uppercase text-iceblue-500 z-30 mt-[6px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
                                            className: "relative",
                                            children: (param)=>/*#__PURE__*/ {
                                                let { open  } = param;
                                                return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                            className: classnames_default()("group rounded-xl md:rounded-3xl font-bold uppercase outline-none py-2.5 -my-2.5 px-5", !open && "bg-white hover:bg-iceblue-100 hover:text-iceblue-500", open && "bg-iceblue-600 text-white hover:bg-iceblue-600 hover:text-white"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GlobeIcon */.n9, {
                                                                    className: "absolute -top-0.5 w-6 h-6"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "ml-6 pl-1 whitespace-nowrap",
                                                                    children: currentLocale
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                                            as: react.Fragment,
                                                            enter: "transition ease-out duration-200",
                                                            enterFrom: "opacity-0 translate-y-1",
                                                            enterTo: "opacity-100 translate-y-0",
                                                            leave: "transition ease-in duration-150",
                                                            leaveFrom: "opacity-100 translate-y-0",
                                                            leaveTo: "opacity-0 translate-y-1",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                                                                className: "absolute left-0 z-20 mt-3 max-w-xs transform -translate-x-3",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "overflow-hidden rounded-xl md:rounded-3xl rounded-t-none md:rounded-t-none border border-blue-100 border-t-0",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "relative grid gap-6 bg-white px-5 py-6 sm:gap-6 sm:p-8 text-11 font-medium",
                                                                        children: locales.map((locale)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: {
                                                                                    pathname: router.pathname,
                                                                                    query: router.query
                                                                                },
                                                                                as: router.asPath,
                                                                                locale: locale,
                                                                                onClick: (e)=>handleLangSwitch(e, locale),
                                                                                className: "-m-3 block p-3",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: classnames_default()("text-blue-800 border-color-800 hover:border-b hover:font-bold uppercase whitespace-nowrap", {
                                                                                        "border-b font-bold": locale === currentLocale
                                                                                    }),
                                                                                    children: Object.entries((i18n_default()).localesLabel).filter((param)=>{
                                                                                        let [key] = param;
                                                                                        return key === locale;
                                                                                    }).map((param)=>{
                                                                                        let [key, value] = param;
                                                                                        return value;
                                                                                    }).join("")
                                                                                })
                                                                            }, locale))
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        menu.items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            className: "py-2.5 -my-2.5 px-5 flex-shrink-0 hover:bg-iceblue-100 rounded-xl md:rounded-3xl",
                                            href: menu.items[menu.items.length - 1].href,
                                            children: menu.items[menu.items.length - 1].title
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        as: react.Fragment,
                        enter: "duration-200 ease-out",
                        enterFrom: "opacity-0 scale-95",
                        enterTo: "opacity-100 scale-100",
                        leave: "duration-100 ease-in",
                        leaveFrom: "opacity-100 scale-100",
                        leaveTo: "opacity-0 scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                            focus: true,
                            className: "fixed inset-x-0 top-0 bottom-0 origin-top-right transform transition lg:hidden bg-iceblue-200 text-blue-800 z-30",
                            children: (param)=>{
                                let { close  } = param;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("px-6 md:px-12", {
                                                "pt-8 pb-[22px]": sticky,
                                                "pb-[22px] pt-8 lg:pt-[80px] lg:pb-[40px]": !sticky
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-start justify-end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("-mr-1", {
                                                        "-mt-3": sticky
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                        className: "inline-flex items-center justify-center text-iceblue-500 p-2 focus:outline-none",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "sr-only",
                                                                children: "Close menu"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                                                                className: "w-[20px]",
                                                                "aria-hidden": "true"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "py-6 px-16",
                                            children: [
                                                menu.items.map((item, index)=>{
                                                    if (item.children) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                                                            children: (param)=>{
                                                                let { open  } = param;
                                                                var _item_children;
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                                                            className: "flex items-center font-bold text-16 leading-140 tracking-8 uppercase w-full py-4",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: item.title
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DownIcon */.KL, {
                                                                                    className: "".concat(open ? "rotate-180 transform" : "", " ml-2 mt-1 w-[12px]"),
                                                                                    "aria-hidden": "true"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                                                            className: "space-y-4 font-medium tracking-4 pt-2 pb-4",
                                                                            children: (_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.map((item, index)=>{
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                                                                    as: (link_default()),
                                                                                    className: "block",
                                                                                    href: item.href,
                                                                                    target: item.target,
                                                                                    children: item.title
                                                                                }, index);
                                                                            })
                                                                        })
                                                                    ]
                                                                });
                                                            }
                                                        }, index);
                                                    }
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                                        as: (link_default()),
                                                        className: "block font-bold text-16 leading-140 tracking-8 text-blue-800 uppercase py-4",
                                                        href: item.href,
                                                        target: item.target,
                                                        children: item.title
                                                    }, index);
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-16",
                                                    children: locales.map((locale)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: {
                                                                pathname: router.pathname,
                                                                query: router.query
                                                            },
                                                            as: router.asPath,
                                                            locale: locale,
                                                            onClick: (e)=>{
                                                                handleLangSwitch(e, locale);
                                                                close();
                                                            },
                                                            className: "-m-3 block p-3",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: classnames_default()("text-blue-800 border-color-800 hover:border-b hover:font-bold uppercase text-13 whitespace-nowrap", {
                                                                    "border-b font-bold": locale === currentLocale
                                                                }),
                                                                children: Object.entries((i18n_default()).localesLabel).filter((param)=>{
                                                                    let [key] = param;
                                                                    return key === locale;
                                                                }).map((param)=>{
                                                                    let [key, value] = param;
                                                                    return value;
                                                                }).join("")
                                                            })
                                                        }, locale))
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./lib/image.ts
var lib_image = __webpack_require__(4327);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/footer.tsx








function Footer(param) {
    let { menu , menuSecondary , address , socialLinks  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
            size: types/* ContainerSize.wide */.B.wide,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-12 gap-x-1.5 md:gap-x-6 pt-20 bg-iceblue-200 rounded-xl md:rounded-3xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-8 col-start-3 md:col-span-5 lg:col-span-3 md:col-start-0 md:pl-16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Logo */.TR, {
                            className: "h-auto w-[180px]"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-8 col-start-3 md:col-span-3 lg:col-span-2 md:col-start-0 my-16 md:my-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-y-4 md:gap-y-5",
                            children: menu.items.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: "block col-span-3 font-bold text-16 md:text-13 leading-[1.6] tracking-8 uppercase w-full",
                                    href: item.href,
                                    target: item.target,
                                    children: item.title
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-8 col-start-3 md:col-span-4 lg:col-span-7 md:col-start-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("address", {
                                className: "text-blue-800 not-italic address",
                                dangerouslySetInnerHTML: {
                                    __html: address
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex gap-3 mt-8",
                                children: socialLinks.map((socialLink)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: socialLink.url,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,lib_image/* buildImageUrl */.Sc)(socialLink.image.thumbnail ? socialLink.image.thumbnail.url : socialLink.image.url),
                                            alt: socialLink.image.alternativeText,
                                            width: 26,
                                            height: 26
                                        })
                                    }, socialLink.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-12 border-t border-white mt-8 md:mt-20 pt-8 md:pt-4 pb-16 md:pb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-12 gap-x-1.5 md:gap-x-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-8 col-start-3 md:col-span-12 md:col-start-0 md:px-20 md:text-right text-16 md:text-13 leading-[1.6] md:leading-7 text-blue-300 flex md:inline-block flex-col gap-[5px]",
                                children: menuSecondary.items.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            i > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mx-4 hidden md:inline",
                                                children: "|"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "hover:underline block md:inline",
                                                href: item.href,
                                                target: item.target,
                                                children: item.title
                                            })
                                        ]
                                    }, i))
                            })
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./components/tracking.tsx + 1 modules
var tracking = __webpack_require__(9807);
;// CONCATENATED MODULE: ./components/layout.tsx







function Layout(param) {
    let { children , isPreview =false , menu , menuFooter , menuFooterSecondary , settings  } = param;
    const [sticky, setSticky] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", isSticky, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", isSticky);
        };
    }, []);
    function isSticky() {
        const scrollTop = window.scrollY;
        setSticky(scrollTop > 100);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-x-0 top-0 z-50 bg-blue-100 text-blue-800 text-15",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between max-w-screen-4xl mx-auto px-6 md:px-12 py-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Vorschaumodus"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/api/exit-preview",
                            children: "Beenden"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col min-h-screen",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {
                        menu: menu,
                        sticky: sticky,
                        trackingConsent: settings.googleAnalytics.consentInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(tracking/* TrackingConsent */.h, {
                            info: settings.googleAnalytics.consentInfo,
                            acceptAllLabel: settings.googleAnalytics.acceptAllLabel,
                            declineAllLabel: settings.googleAnalytics.declineAllLabel
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: classnames_default()("flex-1", {
                            // keep in sync with nav height and container padding
                            "mt-[44px] md:mt-[28px] lg:mt-[46px]": sticky,
                            "mt-[62px] md:mt-[46px] lg:mt-[112px]": !sticky
                        }),
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        menu: menuFooter,
                        menuSecondary: menuFooterSecondary,
                        ...settings.footer
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 9807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ Tracking; },
  "h": function() { return /* binding */ TrackingConsent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(7041);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/button.tsx


var ButtonVariant;
(function(ButtonVariant) {
    ButtonVariant["Primary"] = "Primary";
    ButtonVariant["PrimaryNegative"] = "PrimaryNegative";
    ButtonVariant["Secondary"] = "Secondary";
    ButtonVariant["SecondaryNegative"] = "SecondaryNegative";
})(ButtonVariant || (ButtonVariant = {}));
/**
 * Primary UI component for user interaction
 */ const Button = (param)=>{
    let { variant =ButtonVariant.Primary , label , icon , className , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        type: "button",
        className: classnames_default()("uppercase font-medium text-13 leading-140 tracking-8 inline-flex items-center", {
            "px-5 py-2.5 rounded-xl md:rounded-3xl": variant === ButtonVariant.Primary || ButtonVariant.PrimaryNegative
        }, {
            "bg-blue-500 hover:bg-blue-800 text-white": variant === ButtonVariant.Primary
        }, {
            "bg-white text-blue-500 hover:text-blue-800": variant === ButtonVariant.PrimaryNegative
        }, {
            "text-iceblue-500 hover:text-iceblue-800": variant === ButtonVariant.Secondary
        }, {
            "text-white": variant === ButtonVariant.SecondaryNegative
        }, className),
        ...props,
        children: [
            label,
            icon
        ]
    });
};

;// CONCATENATED MODULE: ./components/tracking.tsx





function Tracking(param) {
    let { trackingId  } = param;
    const consent = (0,lib.getCookie)("localConsent");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(trackingId)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "gtag",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "\n          window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());\n          gtag('config', '".concat(trackingId, "');\n          gtag('consent', 'default', {\n            ad_storage: 'denied',\n            analytics_storage: 'denied',\n          });\n          ")
                }
            }),
            consent === true && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "gconsent",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "\n            gtag('consent', 'update', {\n              ad_storage: 'granted',\n              analytics_storage: 'granted',\n            });\n          "
                }
            })
        ]
    });
}
function TrackingConsent(param) {
    let { info , acceptAllLabel , declineAllLabel  } = param;
    const [consent, setConsent] = (0,react.useState)(true);
    const maxAge = 60 * 60 * 24 * 365;
    (0,react.useEffect)(()=>{
        setConsent((0,lib.getCookie)("localConsent") === true);
    }, []);
    const acceptCookie = ()=>{
        setConsent(true);
        (0,lib.setCookie)("localConsent", "true", {
            maxAge
        });
        gtag("consent", "update", {
            ad_storage: "granted",
            analytics_storage: "granted"
        });
    };
    const denyCookie = ()=>{
        setConsent(true);
        (0,lib.setCookie)("localConsent", "false", {
            maxAge
        });
    };
    if (consent === true) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex w-full items-center border-b-[1px] border-blue-200 ".concat(consent ? "hidden" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full max-w-screen-4xl mx-auto flex-col md:flex-row md:items-center py-3 px-6 md:px-12 gap-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-1 prose tracking-consent",
                    dangerouslySetInnerHTML: {
                        __html: info
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-0 hidden md:flex gap-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                            onClick: denyCookie,
                            label: declineAllLabel,
                            variant: ButtonVariant.Primary
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                            onClick: acceptCookie,
                            label: acceptAllLabel,
                            variant: ButtonVariant.Primary
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-0 flex md:hidden gap-3 w-full justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                            className: "px-0",
                            onClick: denyCookie,
                            label: declineAllLabel,
                            variant: ButtonVariant.PrimaryNegative
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                            className: "px-0",
                            onClick: acceptCookie,
                            label: acceptAllLabel,
                            variant: ButtonVariant.PrimaryNegative
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ContainerSize; }
/* harmony export */ });
var ContainerSize;
(function(ContainerSize) {
    ContainerSize["wide"] = "wide";
    ContainerSize["full"] = "full";
})(ContainerSize || (ContainerSize = {}));


/***/ })

}]);